import { render, staticRenderFns } from "./DeskworksNotification.vue?vue&type=template&id=1133dbc0"
import script from "./DeskworksNotification.vue?vue&type=script&lang=js"
export * from "./DeskworksNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports